import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Note } from '@interfaces';
import { StaticDataService } from '../../../../services';


export function getColumns(util: UtilityService, staticData: StaticDataService) {

	const columns: GridColumn<Note, unknown>[] = [
		buildColumn(util, 'Id', row => row.noteId, { header: 'noteId' }),
		buildColumn(util, 'Text', row => staticData.notecategorys.byId(row.noteCategoryId).name, { header: 'Category' }),
		buildColumn(util, 'Text', row => row.subject, { header: 'Subject' }),
		buildColumn(util, 'Text', row => row.updatedBy, { header: 'Updated By' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated Date' }),
		buildColumn(util, 'Text', row => row.note, { header: 'Note' }),
		buildColumn(util, 'Text', row => row.createdBy, { header: 'Created By', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created Date', hidden: true }),
	];

	return columns;

}